<div class="row">
	<div class="col-md-12">
		<app-components-customerfiles [options]="options"></app-components-customerfiles>
	</div>
</div>